<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		<!-- banner -->
		<qBanner></qBanner>
		
		
	
		
		<div class="read">
			<div class="read-hd">
				<q-title title="选择时间" time="86"></q-title>
				<q-step :step="1"></q-step>
			</div>
			
			<div class="user-info-row fcc">
				<div>
					<span>专家：</span>
					<b>张三</b>
				</div>
				<div>
					<span>当前选择班次：</span>
					<b>下午</b>
				</div>
				
			</div>
			
			
			
			<div class="worktime-list">
				<a class="item on" @click="openUrl('/clinic-payCost')">
					<div class="icon">
						<img src="../../assets/time1.png" >
						<img src="../../assets/time2.png" class="light">
					</div>
					<p>
						2021-12-05
					</p>
					<div class="b">
						08:00-08:30
					</div>
				</a>
				<a class="item" v-for="item in 15" @click="openUrl('/clinic-payCost')">
					<div class="icon">
						<img src="../../assets/time1.png" >
						<img src="../../assets/time2.png" class="light">
					</div>
					<p>
						2021-12-05
					</p>
					<div class="b">
						08:00-08:30
					</div>
				</a>
				
			</div>
			
				
			<div class="list-page fcc">
				<a>上一页</a>
				<span>第</span>
				<span>1/15</span>
				<span>页</span>
				<a>下一页</a>
			</div>
			
			
			
			<div class="foot-buttons fc-bet">
				<a href="/" class="btn-home fcc">
					<img src="../../assets/icon/icon-home.png" >
					<span>首页</span>
				</a>
				
				<a class="btn-return fcc" @click="returnStep()">
					<img src="../../assets/icon/icon-return.png" >
					<span>返回</span>
				</a>
			</div>
		
		</div>
		
	</div>
</template>

<script>
	import qHead from '@/components/q-head/q-head.vue';
	import qBanner from '@/components/q-head/q-banner.vue';
	import qTitle from '@/components/q-read/q-title.vue';
	import qStep from '@/components/q-read/q-step.vue';
	
	
	export default {
		components: {
			qHead,qBanner,qStep,qTitle
		},
		data() {
			return {
				departmentIndex:0,
				departmentList:[
					{
						id:'001',
						name:"内科",
						icon:require("@/assets/ks/nk.png"),
						icon2:require("@/assets/ks/nk2.png")
					},
					{
						id:'002',
						name:"儿科",
						icon:require("@/assets/ks/ek.png"),
						icon2:require("@/assets/ks/ek2.png")
					},
					{
						id:'003',
						name:"感染科",
						icon:require("@/assets/ks/grk.png"),
						icon2:require("@/assets/ks/grk2.png")
					},
					{
						id:'004',
						name:"营养科",
						icon:require("@/assets/ks/yyk.png"),
						icon2:require("@/assets/ks/yyk2.png")
					},
					{
						id:'005',
						name:"外科",
						icon:require("@/assets/ks/wk.png"),
						icon2:require("@/assets/ks/wk2.png")
					},
					{
						id:'006',
						name:"五官科",
						icon:require("@/assets/ks/wgk.png"),
						icon2:require("@/assets/ks/wgk2.png")
					},
					{
						id:'007',
						name:"肝病科",
						icon:require("@/assets/ks/gbk.png"),
						icon2:require("@/assets/ks/gbk2.png")
					},
					{
						id:'008',
						name:"非临床科",
						icon:require("@/assets/ks/flck.png"),
						icon2:require("@/assets/ks/flck2.png")
					},
					{
						id:'009',
						name:"妇产科",
						icon:require("@/assets/ks/fck.png"),
						icon2:require("@/assets/ks/fck.png")
					},
					{
						id:'010',
						name:"肿瘤科",
						icon:require("@/assets/ks/zlk.png"),
						icon2:require("@/assets/ks/zlk2.png")
					},
					{
						id:'011',
						name:"急诊科",
						icon:require("@/assets/ks/jzk.png"),
						icon2:require("@/assets/ks/jzk2.png")
					},
					{
						id:'012',
						name:"成瘾医学科",
						icon:require("@/assets/ks/cyyxk.png"),
						icon2:require("@/assets/ks/cyyxk2.png")
					},
					{
						id:'013',
						name:"男科",
						icon:require("@/assets/ks/nank.png"),
						icon2:require("@/assets/ks/nank2.png")
					},
					{
						id:'014',
						name:"皮肤性病科",
						icon:require("@/assets/ks/pfxbk.png"),
						icon2:require("@/assets/ks/pfxbk2.png")
					},
					{
						id:'015',
						name:"中医科",
						icon:require("@/assets/ks/zyk.png"),
						icon2:require("@/assets/ks/zyk2.png")
					},
					{
						id:'016',
						name:"疼痛专科",
						icon:require("@/assets/ks/ttzk.png"),
						icon2:require("@/assets/ks/ttzk2.png")
					},
					{
						id:'017',
						name:"生殖科",
						icon:require("@/assets/ks/szk.png"),
						icon2:require("@/assets/ks/szk2.png")
					},
					{
						id:'018',
						name:"精神心理科",
						icon:require("@/assets/ks/jsxlk.png"),
						icon2:require("@/assets/ks/jsxlk2.png")
					},
					{
						id:'019',
						name:"体检保健科",
						icon:require("@/assets/ks/tjbjk.png"),
						icon2:require("@/assets/ks/tjbjk2.png")
					},
					{
						id:'020',
						name:"整形美容科",
						icon:require("@/assets/ks/zxmrk.png"),
						icon2:require("@/assets/ks/zxmrk2.png")
					}
					
				]
			}
		},
		mounted() {
			
		},
		methods:{
			
			
		},
		beforeDestroy() {
			//clearInterval(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
	.print-item .btn-print{

			background: linear-gradient(0deg, #029897, #1AB9B4);
			margin-right: 0;
	}
	.print-item-head{
		
		height: 74px;background: #1EB3B1;
		font-size: 30px;
		color: #fff;
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}
	.print-list-tiems{
		.col1{
			width: 87px;text-align: center;
			padding: 0;
			img{
				margin: 0 auto;
			}
		}
		.col2{
			width: 253px;
			text-align: center;
			
		}
		.col3{
			width: 147px;text-align: center;
			font-size: 23px;
			
		}
		.col4{
			width: 249px;text-align: center;
		}
		.col5{
			width: 140px;text-align: center;
		}
		.col6{
			width: 144px;text-align: center;
		}
	}
	.print-item{
		.col2~div{
			font-size: 23px;
			color: #7F7F7F;
		}
	}
	.print-item .name{
		width: 253px;
	}
</style>
